import { TRANSITION_PRODUCT_VIEW_AFTER } from "../components/Barba/Views/constants";

const LG_MIN = 1024;

function isPdpContext(): boolean {
  return (
    document.body.classList.contains("template-product") ||
    document.querySelector("[data-barba-namespace='product']") != null
  );
}

function syncBuyboxStickyTopCssVar(): void {
  if (!isPdpContext()) {
    document.documentElement.style.removeProperty("--pdp-buybox-sticky-top");
    return;
  }
  if (window.innerWidth < LG_MIN) {
    document.documentElement.style.removeProperty("--pdp-buybox-sticky-top");
    return;
  }

  const header =
    document.querySelector<HTMLElement>("#shopify-section-header") ||
    document.querySelector<HTMLElement>("header");
  const ann = document.querySelector<HTMLElement>(".section-announcement-bar");
  const offset = (header?.offsetHeight ?? 64) + (ann?.offsetHeight ?? 0);
  document.documentElement.style.setProperty(
    "--pdp-buybox-sticky-top",
    `${offset}px`
  );
}

let listenersWired = false;

function ensurePdpStickyListeners(): void {
  if (listenersWired) return;
  listenersWired = true;
  window.addEventListener("resize", syncBuyboxStickyTopCssVar);
  window.addEventListener(TRANSITION_PRODUCT_VIEW_AFTER, syncBuyboxStickyTopCssVar);
}

/** Safe to call on every mount: syncs CSS var and wires resize/transition once. */
export function initPdpStickyLayout(): void {
  ensurePdpStickyListeners();
  syncBuyboxStickyTopCssVar();
}
